export { default as useProductsIndexPageBreadcrumbs } from './useProductsIndexPageBreadcrumbs';
